export default __webpack_public_path__ + "static/media/Anuphan-SemiBold.1361ef5e.ttf";